module.exports = function() {
  return new Worker(__webpack_public_path__ + "f9e17d8d34dda2724325.worker.js");
};